import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ChatInputService } from '@app/services/chat-input.service';
import { TabService } from '@app/services/tab.service';
import { ModalService } from '@app/components/modal/modal.service';
import { XMLElementBaseComponent } from '../base';
import { BuildGroup, ExtraRepair, ExtraRepairTitle, RepairNumber } from '../volkswagen.types';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-vw-chapter-link',
  imports: [CommonModule, TranslocoPipe],
  standalone: true,
  template: `
    @if (linkText()) {
      <p>
        <span>{{ 'chat.newSearch' | transloco }}</span>
        <span
          role="button"
          tabindex="0"
          (click)="addSuggestion()"
          (keydown.enter)="addSuggestion()"
          class="!inline p-0 text-left italic text-blue-800 hover:underline">
          {{ linkText() }}
        </span>
        <!-- <span>{{ 'documents.vw.seeAlso' | transloco }}</span>
        <span class="pl-2 italic">{{ linkText() }}</span> -->
      </p>

      <!-- <pre class="bg-violet-50 text-xs">{{ data | json }}</pre> -->
    }
  `,
})
export class ChapterLinkComponent extends XMLElementBaseComponent<ExtraRepair> {
  tabService = inject(TabService);
  chatInputService = inject(ChatInputService);
  modalService = inject(ModalService);
  router = inject(Router);

  repairNumber = computed(() => {
    return (this.data?.children?.filter((child: any) => child.tag === 'rep-num')[0] as RepairNumber) || { children: [] };
  });

  extTitle = computed(() => {
    return this.data?.children?.filter((child: any) => child.tag === 'ext-titel')[0] as ExtraRepairTitle;
  });

  activeTabId = computed(() => this.tabService.activeTab()?._id || null);

  buildGroup = computed(() => {
    return this.data?.children?.filter((child: any) => child.tag === 'baugrup')[0] as BuildGroup;
  });

  linkText = computed(() => {
    const parts: string[] = [];

    if (this.buildGroup()) {
      parts.push(this.buildGroup().text);
    }

    if (this.extTitle()) {
      parts.push(this.extTitle().text);
    }

    if (this.data['ext-ziel']) {
      parts.push('(' + this.data['ext-ziel'] + ')');
    }

    return parts.join(' ');
  });

  addSuggestion() {
    const text = this.linkText();
    const activeTabId = this.activeTabId();
    if (activeTabId) {
      this.modalService
        .confirm('documents.vw.newSearch.title', 'documents.vw.newSearch.content', 'documents.vw.newSearch.btnYes', 'documents.vw.newSearch.btnNo')
        .then((confirmed) => {
          if (confirmed) {
            this.chatInputService.setChatInput(activeTabId, text);
            this.router.navigate(['/chat', activeTabId]);
          }
        });
    } else {
      this.modalService
        .confirm('documents.error.title', 'documents.error.content', 'documents.error.btnYes', 'documents.error.btnNo', 'error')
        .then((confirmed) => {
          if (confirmed) {
            location.reload();
          }
        });
    }
  }
}
